<div class="card flex flex-col md:flex-row sm:mr-2">
  <div class="p-gutter flex-auto max-w-[1000px]">
    <h3 class="body-2 m-0">Reports</h3>
    <div class="operations-scroll mt-4 flex-1 overflow-auto">
      <div #reportOriginRef class="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3"
        [ngClass]="reports.length>4?'row-cols-lg-6':'row-cols-lg-3'">
        <div class="cursorP" *ngFor="let report of reports">
          <a (click)="processOp(report.route,reportOriginRef)"
            class="text-dark pt-3 text-center hover:bg-primary/10 hover:text-primary trans-ease-out rounded block no-underline"
            [class.disabled]="this.operationStatus.isOperationDisabled(report.route,report.id)">
            <mat-icon [svgIcon]="report.icon" class="icon-xl" color="primary"></mat-icon>
            <div class="body-2 mt-2">{{ report.label }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>